import { Cell, CellText, VSpacingContainer } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import formatDate from 'Modules/formatDate';
import translation from 'src/components/translation';
import { EmployerStateExtName } from 'src/models/negotiationTopic.types';
import { NegotiationsHistory } from 'src/models/negotiationsHistory';
import { ARROW_RIGHT, NON_BREAKING_SPACE } from 'src/utils/constants/symbols';

const TrlKeys = {
    [EmployerStateExtName.Response]: 'resume.employer.history.response',
    [EmployerStateExtName.Interview]: 'resume.employer.history.interview',
    [EmployerStateExtName.PhoneInterview]: 'resume.employer.history.phone_interview',
    [EmployerStateExtName.Assessment]: 'resume.employer.history.assessment',
    [EmployerStateExtName.Consider]: 'resume.employer.history.consider',
    [EmployerStateExtName.Hired]: 'resume.employer.history.hired',
    [EmployerStateExtName.Offer]: 'resume.employer.history.offer',
    [EmployerStateExtName.DiscardByEmployer]: 'resume.employer.history.discard_by_employer',
    [EmployerStateExtName.DiscardByApplicant]: 'resume.employer.history.discard_by_applicant',
    [EmployerStateExtName.DiscardNoInteraction]: 'resume.employer.history.discard_no_interaction',
    [EmployerStateExtName.DiscardVacancyClosed]: 'resume.employer.history.discard_vacancy_closed',
    [EmployerStateExtName.DiscardToOtherVacancy]: 'resume.employer.history.discard_to_other_vacancy',
    expDiscardByEmployer: 'resume.employer.history.discard_by_employer.softForm',
};

interface MoreResponsesListProps {
    negotiationsHistory: NegotiationsHistory[];
}

const MoreResponsesList: TranslatedComponent<MoreResponsesListProps> = ({ negotiationsHistory, trls }) => {
    if (!negotiationsHistory.length) {
        return null;
    }

    return (
        <VSpacingContainer default={16}>
            {negotiationsHistory.map((vacancy) => (
                <Cell data-qa="negotiation_history_item" key={vacancy['@vacancyId']}>
                    <CellText type="title">{`${vacancy['@name']}${NON_BREAKING_SPACE}(${vacancy.area.name})`}</CellText>
                    <CellText type="subtitle">
                        <span>
                            <span>{`${ARROW_RIGHT} `}</span>
                            <span>
                                {vacancy.items[0]['@employerStateExtName'] === EmployerStateExtName.DiscardByEmployer
                                    ? `${trls[TrlKeys.expDiscardByEmployer]}, `
                                    : `${trls[TrlKeys[vacancy.items[0]['@employerStateExtName']]]}, `}
                                <span suppressHydrationWarning>
                                    {formatDate(vacancy.items[0]['@changeTime'], 'dd.MM.yy')}
                                </span>
                            </span>
                        </span>
                    </CellText>
                </Cell>
            ))}
        </VSpacingContainer>
    );
};

export default translation(MoreResponsesList);
